import axios from 'axios';
import { notificationDismiss, notificationFetch } from "../slice/notifications";
export const fetchNotifications = () => {
    return (dispatch) => {
        axios.get('/admin/v1/notifications?limit=21')
            .then(response => {
            dispatch(notificationFetch(response.data.results));
        });
    };
};
export const dismissNotification = (notificationId) => {
    return (dispatch) => {
        axios.post('/admin/v1/notifications/' + encodeURIComponent(notificationId) + '/dismiss');
        dispatch(notificationDismiss(notificationId));
    };
};
